/**
 * Editor-body HTML helpers shared by the editor and every reader surface.
 *
 * WHY THIS EXISTS
 * The api stores an editor image as a RELATIVE src (`/v1/core/images/{id}`), so
 * a body stays portable: it carries no stage and no hostname, and copying rows
 * between stages cannot leave images pointing at the wrong environment. But the
 * api is its own origin (`api.ampersandbrands.com`, not the Cockpit host), so a
 * relative src in the page would resolve against Cockpit and return the SPA
 * shell instead of an image. Every surface that renders a body therefore
 * prefixes the API base first.
 *
 * The api accepts either form on write and normalizes back to relative, so the
 * editor may hand back whatever it is holding.
 */

import { API_BASE } from './apiBase';

const RELATIVE_IMAGE_SRC = /(<img\b[^>]*?\bsrc=")(\/v1\/core\/images\/\d+)(")/gi;

/**
 * Point every stored image at the API host so the browser can load it. Applied
 * when rendering a body and when seeding the editor with an existing one.
 */
export function withApiImageSrc(html: string): string {
  return html.replace(RELATIVE_IMAGE_SRC, (_m, pre: string, path: string, post: string) => {
    return `${pre}${API_BASE}${path}${post}`;
  });
}
